<template>
  <!-- 筛选条件 -->
  <div v-if="items.length" class='content flex1'>
    <ul class='search-wrapper mt20 ph20 pb20 pt5'
      :style='{ backgroundColor: bgColor, maxHeight: !showMore ? "9999px" : maxHeight + "px" }'>
      <li v-for="(item, index) in items" :key="index">
        <!-- 区域单选 -->
        <div v-if="item.type == type[0]" class='row  flex1' :class="[index ? 'mt20' : '']">
          <div class='size12 bold lable_width'>{{ item.name }}</div>
          <div class="flex1">
            <ul class="row  wrap region-wrap black">
              <li :style="{ borderColor: companyConfig.themeColor }" class="size12 choose-rengion">区域</li>
            </ul>
            <ul class="row wrap black region-child-wrap">
              <li v-for="(ele, i) in item.data" :key="i" class="row c_center cursor size12 col4d mr20 mb15"
                :class="[ele.name === item.value.name ? 'choose-color-green' : '']"
                @click="regionBottomClick(index, ele)">
                <!-- <div class="box flex c_center mr5 "
                  :class="[ele.name === item.value.name ? 'choose-bottom-rengion' : 'whiteBG']">
                  <i class="el-icon-check white size12"></i>
                </div> -->
                {{ ele.name }}
              </li>
            </ul>
          </div>

        </div>
        <!-- 区域多选 -->
        <!-- <div v-if="item.type == type[5]"
                     class='row s_start mt20'>
                    <div class='size14 bold lable_width'>{{item.name}}</div>
                    <div class='row s_start wrap flex1'>
                        <div v-for="(ele,num) in item.data"
                             :key="num"
                             class='row s_center p5 lable_item cursor flex'
                             @click="handleRegionMultiple(index,ele,num)">
                            <img v-if="item.select[num]"
                                 class='mh10'
                                 style='width: 13px;height: 13px;'
                                 src='@/assets/imgs/erp_icon_box_blue.png' />
                            <img v-else
                                 class='mh10'
                                 style='width: 13px;height: 13px;'
                                 src='@/assets/imgs/erp_icon_box_empty.png' />
                            <div class='size14 ellipsis flex1'
                            style="width:100%"
                            :title="ele[item.label]">{{ ele[item.label] }}</div>
                        </div>
                    </div>
                </div> -->
        <!-- 范围 -->
        <!-- <div v-else-if="item.type == type[1]"
                     class='row s_start mt20'>
                    <div class='size14 bold lable_width'>{{item.name}}</div>
                    <div class='row s_start wrap flex1'>
                        <div v-for="(ele,num) in item.data"
                             :key="num"
                             class='row s_center p5 lable_item cursor'
                             @click="singeClick(index,ele)">
                            <img v-if="item.disable"
                                 class='mh10'
                                 style='width: 13px;height: 13px;'
                                 src='@/assets/imgs/erp_icon_box_disable.png' />
                            <img v-else-if="ele.name == item.select.name"
                                 class='mh10'
                                 style='width: 13px;height: 13px;'
                                 src='@/assets/imgs/erp_icon_box_blue.png' />
                            <img v-else
                                 class='mh10'
                                 style='width: 13px;height: 13px;'
                                 src='@/assets/imgs/erp_icon_box_empty.png' />
                            <div class='size14'>{{ ele.name }}</div>
                        </div>
                    </div>
                </div> -->

        <!-- 范围 + 自定义 -->
        <div v-else-if="item.type == type[2]" class='row s_start relative'>
          <div class='size14 bold lable_width'>{{ item.name }}</div>
          <ul class="flex wrap black flex1 hidden transition size12"
            :style="{ maxHeight: multipleMaxHeight[index] + 'px' }">
            <li v-for="(ele, i) in item.data" :key="i" class="row s_center cursor  col4d lable-item"
              @click="multipleClick(index, ele.value, item.disabled, item.key)">
              <div class="box flex c_center mr5 "
                :class="[item.value.includes(ele.value) ? 'choose-bottom-rengion' : item.disabled ? 'boldGrayBG' : 'whiteBG']">
                <i v-show="item.value.includes(ele.value) || item.disabled" class="el-icon-check white"></i>
              </div>
              {{ ele.name }}
            </li>
            <li v-show="!item.value.length" class="flex custom-filter ">
              <input type="text" :disabled="item.disabled" v-model="item.input.minValue" maxlength="6"
                @input="e => singeInput(e, index, 1, item.disabled, item.key)" />
              <span>-</span>
              <input type="text" :disabled="item.disabled" v-model="item.input.maxValue"
                @input="e => singeInput(e, index, 2, item.disabled, item.key)" />
              <span>{{ item.company }}</span>
              <a v-show="item.input.maxValue || item.input.minValue" @click="handleConfirm(index)" href="javascript:;"
                class="btn-range banner-bg ">确定</a>
            </li>
          </ul>
          <span @click="handleShowMore(index)" v-show="item.data.length > 6 && multipleMaxHeight[index] === 27"
            class="cursor btn-showmore size12">+ 更多及自定义</span>
        </div>

        <!-- 单值 -->
        <div v-else-if="item.type == type[3]" class='flex relative'>
          <div class='size14 bold lable_width'>{{ item.name }}</div>
          <ul class='flex wrap black flex1 hidden transition size12'
            :style="{ maxHeight: multipleMaxHeight[index] + 'px' }">
            <li v-for="(ele, num) in item.data" :key="num" class='row s_center cursor  col4d lable-item'
              @click="singeClick(index, ele)">

              <div class="box flex c_center mr5 "
                :class="[item.value.value === ele.value ? 'choose-bottom-rengion' : 'whiteBG']">
                <i v-show="item.value.value === ele.value" class="el-icon-check white "></i>
              </div>
              {{ ele.name }}
            </li>
          </ul>
          <span @click="handleShowMore(index)" v-show="item.data.length > 6 && multipleMaxHeight[index] === 27"
            class="cursor size12  btn-showmore">+ 展开全部</span>
        </div>
        <!-- 单值+自定义 -->
        <div v-else-if="item.type == type[6]" class='flex relative'>
          <div class='size14 bold lable_width'>{{ item.name }}</div>
          <ul class='flex wrap black flex1 hidden transition size12'
            :style="{ maxHeight: multipleMaxHeight[index] + 'px' }">
            <li v-for="(ele, num) in item.data" :key="num" class='row s_center cursor  col4d lable-item'
              @click="singeClick(index, ele, item.disabled, item.key)">

              <div class="box flex c_center mr5 "
                :class="[item.value.value === ele.value ? 'choose-bottom-rengion' : item.disabled ? 'boldGrayBG' : 'whiteBG']">
                <i v-show="item.value.value === ele.value || item.disabled" class="el-icon-check white "></i>
              </div>
              {{ ele.name }}
            </li>
            <li v-show="!item.value.value" class="flex custom-filter ">
              <input type="text" :disabled="item.disabled" v-model="item.input.minValue" maxlength="6"
                @input="e => singeInput(e, index, 1, item.disabled, item.key)" />
              <span>-</span>
              <input type="text" :disabled="item.disabled" v-model="item.input.maxValue"
                @input="e => singeInput(e, index, 2, item.disabled, item.key)" />
              <span>{{ item.company }}</span>
              <a v-show="item.input.maxValue || item.input.minValue" @click="handleConfirm(index)" href="javascript:;"
                class="btn-range banner-bg ">确定</a>
            </li>
          </ul>
          <span @click="handleShowMore(index)" v-show="item.data.length > 6 && multipleMaxHeight[index] === 27"
            class="cursor size12  btn-showmore">+ 展开全部</span>
        </div>
        <!-- 多选 -->
        <div v-else-if="item.type == type[4]" class='flex relative '>
          <div class='size14 bold lable_width'>{{ item.name }}</div>
          <ul class="flex wrap black flex1 hidden transition size12"
            :style="{ maxHeight: multipleMaxHeight[index] + 'px' }">
            <li v-for="(ele, i) in item.data" :key="i" class="row s_center cursor  col4d lable-item"
              @click="multipleClick(index, ele.value)">
              <div class="box flex c_center mr5 "
                :class="[item.value.includes(ele.value) ? 'choose-bottom-rengion' : 'whiteBG']">
                <i v-show="item.value.includes(ele.value)" class="el-icon-check white "></i>
              </div>
              {{ ele.name }}
            </li>
          </ul>
          <span @click="handleShowMore(index)" v-show="item.data.length > 6 && multipleMaxHeight[index] === 27"
            class="cursor size12  btn-showmore">+ 展开全部</span>
        </div>
      </li>
    </ul>
    <div class="more-wrapper" v-if="items.length > 4">
      <div class="more-btn" @click="updateShowMore">
        <span>{{ showMore ? '更多选项' : '收起选项' }}</span>
        <i :class="[showMore ? 'el-icon-arrow-down' : 'el-icon-arrow-up']"></i>
      </div>
    </div>
  </div>
</template>

<script>
//   key: "region",  设置数据标识
//   type: "region", 渲染视图标识
//   name: "区域",    Label名称
//   select: {},     选中数据item 多选为【item，item】
//   input: {},      自定义输入 {name: '不限',min: 0,max: 1000}
//   unit: "层",     自定义输入 单位
//   label: "label", 区域单独使用 取值Label值的key
//   value: "value", 区域单独使用 取值Value值的key
//   children: "children", 区域单独使用 取值Children值的key
//   data: []        源数据
//                         格式1 范围 {name: '不限',min: 0,max: 1000},
//                         格式2 单选 {name: '不限',value: 0},
//                         格式2 区域 {lable: '不限',value: 0,children:[]},
import tool from "../utils/tool";
import { mapState } from "vuex";

export default {
  name: "SearchBar",
  props: {
    items: {
      type: Array,
      required: true
    },
    bgColor: {
      type: String,
      default: "#FBFBFB"
    },
    updateChildren: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    items(newVal, val) {
      if (newVal.length !== val.length) {
        this.multipleMaxHeight = new Array(newVal.length).fill(27);
      }
    },
    updateChildren(newVal, val) {
      if (newVal !== val) {
        const _multipleMaxHeight = [...this.multipleMaxHeight].fill(27);
        this.multipleMaxHeight = _multipleMaxHeight;
        this.maxHeight = 140;
      }
    }
  },
  data() {
    return {
      // 区域 范围   范围+自定义  单值  多选 区域多选
      type: [
        "region",
        "range_value",
        "range_value_input",
        "single_value",
        "single_value_multiple",
        "region_multiple",
        "single_value_input"
      ],
      multipleMaxHeight: [],
      maxHeight: 140,
      showMore: true
    };
  },
  computed: { ...mapState(["companyConfig"]) },
  methods: {
    deepCopy(data) {
      let obj = {};
      obj = JSON.parse(JSON.stringify(data));
      return obj;
    },

    regionClick(index, choose) {
      const obj = this.deepCopy(this.items);
      obj[index].selectedData = choose;
      this.sendParamsEmit({ data: obj, isRefresh: false });
    },
    regionBottomClick(index, choose) {
      const obj = this.deepCopy(this.items);
      if (obj[index].value.value === choose.value) {
        obj[index].value = {};
      } else {
        obj[index].value = choose;
      }
      this.sendParamsEmit({ data: obj, isRefresh: true });
    },
    /* 多选 展开全部 */
    handleShowMore(index) {
      const _multipleMaxHeight = [...this.multipleMaxHeight];
      _multipleMaxHeight[index] = 999;
      this.multipleMaxHeight = _multipleMaxHeight;
      this.maxHeight += 27;
      this.$emit("update-children", false);
    },
    singeClick(index, choose, disable, key) {
      if (disable) {
        return
      }
      const obj = this.deepCopy(this.items);

      if (obj[index].value.value === choose.value) {
        obj[index].value = {};
      } else {
        obj[index].value = choose;
      }
      if (key == 'avgPrice') {
        obj.map(item => {
          if (item.key == 'price') {
            if (obj[index].value.value) {
              item.disabled = true
            } else {
              item.disabled = false
            }
          }
        })
      }

      this.sendParamsEmit({ data: obj });
    },
    handleRegionMultiple(index, choose, num) {
      let obj = this.deepCopy(this.items);
      if (obj[index].select[num]) {
        delete obj[index].select[num];
      } else {
        obj[index].select[num] = choose;
      }
      this.sendParamsEmit(obj);
    },
    multipleClick(index, value, disabled, key) {
      if (disabled) {
        return
      }
      const data = this.deepCopy(this.items);

      const current = data[index];
      if (current.value.includes(value)) {
        current.value = current.value.filter(_ => _ !== value);
      } else {
        current.value.push(value);
      }

      if (key == 'price') {
        data.map(item => {
          if (item.key == 'avgPrice') {
            if (current.value.length) {
              item.disabled = true
            } else {
              item.disabled = false
            }
          }
        })
      }
      this.sendParamsEmit({ data });
    },
    singeInput(e, index, num, disabled, key) {
      if (disabled) {
        return
      }
      const data = this.deepCopy(this.items);

      if (key == 'price') {
        data.map(item => {
          if (item.key == 'avgPrice') {
            if (e.target.value) {
              item.disabled = true
            } else {
              item.disabled = false
            }
          }
        })
      } else if (key == 'avgPrice') {
        data.map(item => {
          if (item.key == 'price') {
            if (e.target.value) {
              item.disabled = true
            } else {
              item.disabled = false
            }
          }
        })
      }

      const cur = data[index];
      cur.input[num === 1 ? "minValue" : "maxValue"] = tool.isNumber(
        e.target.value
      );
      this.sendParamsEmit({ data, isRefresh: false });
    },
    handleConfirm(index) {
      const data = this.deepCopy(this.items);
      const cur = data[index];
      if (cur.input.minValue || cur.input.maxValue) {
        if (+cur.input.minValue > +cur.input.maxValue) {
          [cur.input.minValue, cur.input.maxValue] = [
            cur.input.maxValue,
            cur.input.minValue
          ];
        }
      }
      this.sendParamsEmit({ data, isRefresh: true });
    },
    // 回传
    sendParamsEmit(obj) {
      this.$emit("sendParamsEmit", obj);
    },
    updateShowMore() {
      this.showMore = !this.showMore;
      if (!this.showMore) {
        this.maxHeight = 140;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.btn-range {
  width: 35px;
  padding: 0px;
  color: #ffffff;
  line-height: 20px;
  text-align: center;
  height: 20px;
}

.custom-filter {
  input {
    width: 35px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    border: 1px solid #b7b7b7;
    outline: none;
  }

  span {
    line-height: 20px;
    margin: 0 5px;
  }
}

.btn-showmore {
  position: absolute;
  right: 0;
  top: 0;
  line-height: 27px;
  color: #a7a8a9;
}

.lable-item {
  color: #101d37;
  position: relative;
  line-height: 27px;
  height: 27px;
  width: 150px;
  flex-shrink: 0;
}

.box {
  width: 14px;
  height: 14px;
  border: 1px solid #cccccc;
  border-radius: 2px;
  box-sizing: border-box;
  box-shadow: 0 0 10px rgba(204, 204, 204, 0.4) inset;
}

.region-child-wrap {
  margin-top: 10px;
  padding-top: 15px;
  margin-bottom: 10px;
  border-top: 1px solid #f1f1f1;
  border-bottom: 1px solid #f1f1f1;

  .cursor {
    &:hover {
      font-weight: 600;
    }
  }
}

.choose-bottom-rengion {
  background: #00ae66;
  border: none;
}

.choose-color-green {
  color: #00ae66;
}

.region-wrap {
  li {
    position: relative;
    height: 17px;
    line-height: 17px;
    margin-right: 18px;
    padding: 5px 0;
  }

  .choose-rengion {
    border-bottom: 2px solid;
  }
}

.lable_width {
  width: 64px;
  height: 27px;
  line-height: 27px;
}

.search-wrapper {
  max-height: 260px;
  overflow: hidden;
  transition: all 400ms;
}

.more-btn {
  width: 200px;
  margin: 0 auto;
  padding: 10px 0;
  color: #a7a8a9;
  text-align: center;
  cursor: pointer;
}

.more-wrapper {
  background-color: #fbfbfb;
  border-bottom: 1px solid #eee;
}
</style>